import { FC, PropsWithChildren } from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Column } from 'further-ui/components/Layout';

const FieldGroupContainer = styled(Column)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.sm),
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
}));

type Props = {
  title: string;
};

const FieldGroup: FC<PropsWithChildren<Props>> = ({ title, children }) => (
  <FieldGroupContainer spacing="sm">
    <Typography variant="caption" color="grey.500" padding="8px">
      {title}
    </Typography>
    {children}
  </FieldGroupContainer>
);

export default FieldGroup;
